import React from 'react';
import { Box, Text, Center, Image } from '@chakra-ui/react';

const Footer: React.FC = () => {
  return (
    <Box py={4} borderTopWidth="1px" borderColor="gray.200">
      <Center flexDirection="column">
        <Image 
          src="/letsparky-logo.png" 
          alt="LetsParky Logo" 
          width={40}
        />
        <Text mt={2} fontSize="xs" color="gray.500">
          Powered by Letsparky
        </Text>
      </Center>
    </Box>
  );
};

export default Footer; 